 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLFM01 from '@/components/xhtml/fm01'
 import XHTMLAUTHOR1 from '@/components/xhtml/author1'
 import XHTMLAUTHOR2 from '@/components/xhtml/author2'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLMAPS from '@/components/xhtml/maps'
 import XHTMLTABLES from '@/components/xhtml/tables'
 import XHTMLGUIDE from '@/components/xhtml/guide'
 import XHTMLCHAPTER01 from '@/components/xhtml/chapter01'
 import XHTMLCHAPTER01_1 from '@/components/xhtml/chapter01_1'
 import XHTMLCHAPTER01_12 from '@/components/xhtml/chapter01_12'
 import XHTMLCHAPTER02 from '@/components/xhtml/chapter02'
 import XHTMLCHAPTER02_1 from '@/components/xhtml/chapter02_1'
 import XHTMLCHAPTER03 from '@/components/xhtml/chapter03'
 import XHTMLCHAPTER03_1 from '@/components/xhtml/chapter03_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/ack",
 			"name" : "xhtml/ack",
 			"component" : XHTMLACK
 		},
 		{
 			"path" : "/xhtml/maps",
 			"name" : "xhtml/maps",
 			"component" : XHTMLMAPS
 		},
 		{
 			"path" : "/xhtml/tables",
 			"name" : "xhtml/tables",
 			"component" : XHTMLTABLES
 		},
 		{
 			"path" : "/xhtml/guide",
 			"name" : "xhtml/guide",
 			"component" : XHTMLGUIDE
 		},
 		{
 			"path" : "/xhtml/chapter01",
 			"name" : "xhtml/chapter01",
 			"component" : XHTMLCHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js